// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import ConversationsPage from './ConversationsPage';
import ChatPage from './ChatPage';

// Componente para proteger la ruta del chat
const ProtectedRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    return isAuthenticated ? children : <Navigate to="/" />;
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route
                    path="/conversations"
                    element={
                        <ProtectedRoute>
                            <ConversationsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/chat/:contacto"
                    element={
                        <ProtectedRoute>
                            <ChatPage />
                        </ProtectedRoute>
                    }
                />
                {/* Ruta de compatibilidad - redirige /chat a /conversations */}
                <Route
                    path="/chat"
                    element={<Navigate to="/conversations" replace />}
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;